import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* endSessionSaga() {
  yield call(SignalingSocket.send, { event: 'endSession' });
}
